<script setup>
import {
  PhxButton,
  PhxStrapFinderMedia,
  PhxStrapFinderOptions,
  PhxStrapFinderOptionsAction,
  PhxStrapFinderOptionsContent,
  PhxStrapFinderOptionsHead,
  PhxStrapFinderSection,
} from '@phx-styleguides/iwc';

import { props as defaultProps } from '@maison/composables/strapFinder/useSection';

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  ...defaultProps,
  id: {
    type: String,
    required: true,
  },
  preTitle: {
    type: String,
    default: '',
  },
  nextSectionId: {
    type: String,
    default: '',
  },
  actionText: {
    type: String,
    default: '',
  },
});

const { t } = useI18n();

const _actionText = computed(() => props.actionText || t('StrapFinderConfigurator.section.next'));
</script>

<template>
  <phx-strap-finder-section :id="id" v-slot="{ isValid, onScrollTo }">
    <phx-strap-finder-media>
      <slot name="media" />
    </phx-strap-finder-media>

    <phx-strap-finder-options v-slot="{ onShowMedia }">
      <phx-strap-finder-options-head :title="title" :pre-title="preTitle">
        <div v-if="description" class="rich-text" v-html="description" />
      </phx-strap-finder-options-head>

      <phx-strap-finder-options-content>
        <slot :on-show-media="onShowMedia" />

        <div v-if="memo" class="text-muted">
          {{ memo }}
        </div>
      </phx-strap-finder-options-content>

      <phx-strap-finder-options-action>
        <slot name="action">
          <phx-button
            class="btn--plain btn--primary"
            :disabled="!isValid"
            :label="_actionText"
            @click="onScrollTo(nextSectionId)"
          />
        </slot>
      </phx-strap-finder-options-action>
    </phx-strap-finder-options>
  </phx-strap-finder-section>
</template>
